import type { HttpClient } from '@packages/shared/core/common/services';
import { ApiError } from '@packages/shared/core/common/errors';
import { normalizeError } from '@packages/shared/core/common/utils/errors';
import { ApiPathAskGateway } from '@packages/shared/core/common/constants/apiPaths';
import type { FormSubmissionParams } from '../entities';
import type { SupportFormService } from '../interfaces';
import { createFormDataFromSubmissionParams } from '../utils';

export class ZendeskSupportFormService implements SupportFormService {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async submitSupportForm(params: FormSubmissionParams, attachments: Array<File> = []): Promise<void> {
    const formData = createFormDataFromSubmissionParams(params, attachments);

    try {
      await this.httpClient.post(ApiPathAskGateway.ZENDESK_SUPPORT_FORMS_SUBMIT, {
        data: formData,
      });
    } catch (error) {
      const normalizedError = normalizeError(error);

      if (normalizedError instanceof ApiError) {
        throw new Error(`Unable to submit form: ${normalizedError.message || 'Server error occurred'}`);
      }

      throw new Error(`Unable to submit form: ${normalizedError.message || 'Unknown error occurred'}`);
    }
  }
}
